import React from 'react';
import { motion } from 'framer-motion';

const StatCard = ({ title, value, icon, description, color = 'blue' }) => {
  const colorClasses = {
    blue: 'bg-blue-50 text-blue-700 border-blue-100',
    red: 'bg-red-50 text-red-700 border-red-100',
    green: 'bg-green-50 text-green-700 border-green-100',
    amber: 'bg-amber-50 text-amber-700 border-amber-100',
    indigo: 'bg-indigo-50 text-indigo-700 border-indigo-100',
    pink: 'bg-pink-50 text-pink-700 border-pink-100',
    purple: 'bg-purple-50 text-purple-700 border-purple-100'
  };

  const iconColorClasses = {
    blue: 'text-blue-500',
    red: 'text-red-500',
    green: 'text-green-500',
    amber: 'text-amber-500',
    indigo: 'text-indigo-500',
    pink: 'text-pink-500',
    purple: 'text-purple-500'
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className={`bg-white rounded-xl shadow-sm p-6 border-l-4 ${colorClasses[color] || colorClasses.blue}`}
    >
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
          <p className="text-sm text-gray-500 mt-1">{description}</p>
        </div>
        <div className={`w-12 h-12 rounded-full flex items-center justify-center ${color ? `bg-${color}-100` : 'bg-blue-100'}`}>
          {icon}
        </div>
      </div>
      <p className="mt-4 text-3xl font-bold text-gray-900">{value}</p>
    </motion.div>
  );
};

export default StatCard;
